import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { staffAdminDestination } from '@/adminHost';

/** app.datacord.com/admin* → admin.datacord.com, keeping path/query. */
export default function AppAdminRedirect() {
  const location = useLocation();

  useEffect(() => {
    window.location.replace(staffAdminDestination(location.pathname, location.search, location.hash));
  }, [location.hash, location.pathname, location.search]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
      <Spin size="large" />
    </div>
  );
}
